interface String {
    reformat(this: string): string;
}

/**
   * Formateamos las tarifas para que se muestre '?' en vez de '-'
   * o '0:00'. Hacemos esto desde front para evitar modificar los 
   * datos y provocar problemas a futuro.
   */
String.prototype.reformat = function (this: string) {
    const str = this.trim();
    if (str !== "0.00" && str !== "0:00" && str !== "0") return str;
    return "-";
};



// WEBPACK FOOTER //
// ./src/app/string.extensions.ts